// extracted by mini-css-extract-plugin
module.exports = {"level":"styles-module__level___1I-k0","label":"styles-module__label___3OYxW","icon":"styles-module__icon___35jnG","iconFilled":"styles-module__iconFilled___CCJY4"};